import React from 'react'

interface CheckCircleIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function CheckCircleIcon({ className, color = '#1A1A1A', ...props }: CheckCircleIconProps) {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      {...props}
    >
      <path 
        d="M20.8745 12.0005C20.8745 7.09912 16.9018 3.12526 12.0005 3.125C7.09896 3.125 3.125 7.09896 3.125 12.0005C3.12526 16.9018 7.09912 20.8745 12.0005 20.8745C16.9016 20.8742 20.8742 16.9016 20.8745 12.0005ZM23.1245 12.0005C23.1242 18.1443 18.1443 23.1242 12.0005 23.1245C5.85648 23.1245 0.875264 18.1444 0.875 12.0005C0.875 5.85632 5.85632 0.875 12.0005 0.875C18.1444 0.875264 23.1245 5.85648 23.1245 12.0005Z" 
        fill={color}
      />
      <path 
        d="M15.7046 8.20459C16.1439 7.76525 16.8561 7.76525 17.2954 8.20459C17.7347 8.64393 17.7347 9.35607 17.2954 9.79541L11.2954 15.7954C10.8561 16.2347 10.1439 16.2347 9.70459 15.7954L6.70459 12.7954L6.62695 12.7104C6.26649 12.2686 6.29268 11.6165 6.70459 11.2046C7.1165 10.7927 7.76858 10.7665 8.21045 11.127L8.29541 11.2046L10.5 13.4092L15.7046 8.20459Z" 
        fill={color}
      />
    </svg>
  )
} 